// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"9cfe6995","853":"421cc695"}[chunkId] + ".chunk.css";
};